import React from 'react';
import Icon from '../../../components/AppIcon';

const SustainabilitySection = () => {
  const practices = [
    {
      icon: "Recycle",
      title: "Eco-Friendly Packaging",
      description: "Using biodegradable and recyclable packaging materials to minimize environmental impact. Our containers are made from sustainable sources.",
      stats: "100% Recyclable"
    },
    {
      icon: "Droplets",
      title: "Water Conservation",
      description: "Implementing water-efficient equipment and practices in our kitchen operations, reducing water waste by 40% compared to industry standards.",
      stats: "40% Less Water"
    },
    {
      icon: "Leaf",
      title: "Local Sourcing",
      description: "Partnering with local farmers reduces transportation emissions while supporting the local economy and ensuring fresher ingredients.",
      stats: "85% Local Produce"
    },
    {
      icon: "Lightbulb",
      title: "Energy Efficiency",
      description: "Using energy-efficient appliances and LED lighting throughout our facility, reducing our carbon footprint and operational costs.",
      stats: "30% Energy Saved"
    },
    {
      icon: "Heart",
      title: "Food Waste Reduction",
      description: "Implementing portion control and donation programs to minimize food waste. Excess food goes to local community programs.",
      stats: "Zero Food Waste"
    },
    {
      icon: "Users",
      title: "Community Education",
      description: "Teaching sustainable practices to our team and customers, promoting environmental awareness throughout our community.",
      stats: "25+ Staff Trained"
    }
  ];

  return (
    <section className="py-12 md:py-16 lg:py-20 bg-card">
      <div className="max-w-7xl mx-auto px-4 md:px-6 lg:px-8">
        <div className="text-center mb-8 md:mb-12">
          <div className="inline-flex items-center gap-2 bg-accent/10 px-4 py-2 rounded-full mb-4">
            <Icon name="Leaf" size={20} color="var(--color-accent)" />
            <span className="text-accent font-semibold text-sm md:text-base">Sustainability</span>
          </div>
          <h2 className="text-2xl md:text-3xl lg:text-4xl font-bold text-foreground mb-3 md:mb-4">
            Our Environmental Commitment
          </h2>
          <p className="text-base md:text-lg text-muted-foreground max-w-2xl mx-auto">
            Building a sustainable future for South Sudan, one meal at a time
          </p>
        </div>
        
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 md:gap-8 mb-12 md:mb-16">
          {practices?.map((practice, index) => (
            <div
              key={index}
              className="bg-background rounded-xl p-4 md:p-6 border border-border hover:shadow-lg transition-shadow duration-300"
            >
              <div className="flex items-start justify-between mb-4">
                <div className="w-12 h-12 md:w-14 md:h-14 bg-accent/10 rounded-full flex items-center justify-center">
                  <Icon name={practice?.icon} size={24} color="var(--color-accent)" />
                </div>
                <span className="bg-accent/10 text-accent px-3 py-1 rounded-full text-xs md:text-sm font-semibold whitespace-nowrap">
                  {practice?.stats}
                </span>
              </div>
              
              <h3 className="text-lg md:text-xl font-bold text-foreground mb-2 md:mb-3">
                {practice?.title}
              </h3>
              <p className="text-sm md:text-base text-muted-foreground leading-relaxed">
                {practice?.description}
              </p>
            </div>
          ))}
        </div>
        
        <div className="bg-gradient-to-br from-accent/10 to-accent/5 rounded-xl p-6 md:p-8 border border-accent/20">
          <div className="flex flex-col md:flex-row items-start md:items-center gap-4 md:gap-6 mb-6">
            <div className="w-16 h-16 md:w-20 md:h-20 bg-accent rounded-full flex items-center justify-center flex-shrink-0">
              <Icon name="Target" size={32} color="#FFFFFF" />
            </div>
            <div className="flex-1">
              <h3 className="text-xl md:text-2xl font-bold text-foreground mb-2">
                Our 2026 Sustainability Goals
              </h3>
              <p className="text-sm md:text-base text-muted-foreground">
                We're committed to continuous improvement in our environmental practices
              </p>
            </div>
          </div>
          
          <div className="grid grid-cols-1 md:grid-cols-3 gap-4 md:gap-6">
            <div className="bg-background/80 backdrop-blur-sm p-4 rounded-lg border border-border">
              <div className="flex items-center gap-3 mb-2">
                <Icon name="Package" size={20} color="var(--color-accent)" />
                <h4 className="font-bold text-foreground">Packaging</h4>
              </div>
              <p className="text-sm text-muted-foreground">
                Transition to 100% compostable packaging by end of 2026
              </p>
            </div>
            
            <div className="bg-background/80 backdrop-blur-sm p-4 rounded-lg border border-border">
              <div className="flex items-center gap-3 mb-2">
                <Icon name="Zap" size={20} color="var(--color-accent)" />
                <h4 className="font-bold text-foreground">Energy</h4>
              </div>
              <p className="text-sm text-muted-foreground">
                Install solar panels to power 50% of our operations
              </p>
            </div>
            
            <div className="bg-background/80 backdrop-blur-sm p-4 rounded-lg border border-border">
              <div className="flex items-center gap-3 mb-2">
                <Icon name="Sprout" size={20} color="var(--color-accent)" />
                <h4 className="font-bold text-foreground">Sourcing</h4>
              </div>
              <p className="text-sm text-muted-foreground">
                Increase local organic produce sourcing to 95%
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default SustainabilitySection;